import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import classnames from "classnames";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberFormat from "react-number-format";

import "./CampaignListItem.css";
import { CAMPAIGN_STATE } from "../_constants/campaign.constants";
import { gbConstants, THEME } from "../_constants";
import { history } from "../_helpers";
import Campaign from "../_helpers/campaign";
import { campaignService } from "../_services";
import { alertActions, campaignActions } from "../_actions";

const styles = theme => ({
    container: {
        display: "flex",
        flexDirection: "row",
        paddingBottom: 30
    },
    statusBar: {
        flexBasis: 5
    },
    card: {
        flex: 1
    },
    card_hover: {
        flex: 1,
        "&:hover": {
            backgroundColor: THEME.COLOR.WHITE_HOVER
        }
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto"
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    infoItem: {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline"
    },
    infoItem_title: {
        flexBasis: 150
    },
    infoItem_value: {
        flex: 1
    },
    progressInfo: {
        paddingTop: 10,
        paddingBottom: 10
    },
    progressInfo_texts: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    progressInfo_title: {
        width: "auto",
        textAlign: "left"
    },
    progressInfo_value: {
        width: "auto",
        textAlign: "right"
    },
    stateArea: {
        marginTop: 10
    },
    actionButton: {
        color: "white"
    },
    actionButton_blue: {
        backgroundColor: THEME.COLOR.BLUE,
        "&:hover": {
            backgroundColor: THEME.COLOR.BLUE_HOVER
        }
    },
    actionButton_green: {
        backgroundColor: THEME.COLOR.GREEN,
        "&:hover": {
            backgroundColor: THEME.COLOR.GREEN_HOVER
        }
    },
    actionButton_yellow: {
        backgroundColor: THEME.COLOR.YELLOW,
        "&:hover": {
            backgroundColor: THEME.COLOR.YELLOW_HOVER
        }
    },
    stateText: {
        fontStyle: "italic"
    }
});

class CampaignListItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = { expanded: false };
    }

    handleExpandClick = e => {
        e.stopPropagation();

        this.setState(state => ({ expanded: !state.expanded }));
    };

    submit(e, campaign) {
        e.preventDefault();
        e.stopPropagation();

        campaignService
            .updateCampaignState(campaign.id, CAMPAIGN_STATE.TOBEREVIEWED.value)
            .then(
                successfulData => {
                    this.props.dispatch(campaignActions.getAll());
                },
                error => {
                    this.props.dispatch(alertActions.error(error));
                }
            );
    }
    resume(e,campaign){
        e.preventDefault();
        e.stopPropagation();

        Campaign.resumeCampaign(campaign, this.props);
    }
    start(e, campaign) {
        e.preventDefault();
        e.stopPropagation();

        Campaign.startCampaign(campaign, this.props);
    }

    pause(e, campaign) {
        e.preventDefault();
        e.stopPropagation();

        this.props.dispatch(alertActions.loading("Loading...."));

        campaignService
            .updateCampaignState(campaign.id, CAMPAIGN_STATE.PAUSED.value)
            .then(
                successfulData => {
                    this.props.dispatch(campaignActions.getAll());
                },
                error => {
                    this.props.dispatch(alertActions.error(error));
                }
            );
    }

    finish(e, campaign) {
        e.preventDefault();
        e.stopPropagation();
        Campaign.finishCampaign(campaign, this.props)
    }

    remove(e, campaign) {
        e.preventDefault();
        e.stopPropagation();

        Campaign.removeCampaign(campaign, this.props);
    }

    onClickCampaign(e, campaign) {
        e.preventDefault();

        if (
            campaign.state === CAMPAIGN_STATE.DRAFTED.value ||
            campaign.state === CAMPAIGN_STATE.TOBEREVIEWED.value ||
            campaign.state === CAMPAIGN_STATE.DENIED.value ||
            campaign.state === undefined
        ) {
            this.props.dispatch(campaignActions.checkUpdate(0))
            this.props.onEdit(e, campaign);
        } else if (campaign.state === CAMPAIGN_STATE.APPROVED.value) {

        }else {
            this.openDetail();
        }
    }

    openDetail() {
        history.push({
            pathname: gbConstants.PATH_CAMPAIGN_DETAIL,
            state: { campaign:this.props.campaignList[this.props.idx], campaignList: this.props.campaignList }
        });
    }

    render() {
        const { t, classes, color,idx } = this.props;
        const campaign=this.props.campaignList[idx]
        const self = this;

        function renderStatusBar() {
            let statusColor = Campaign.getColor(campaign);
            let colorFromProps = color ? color : statusColor;
            let colorIfCardExpanded = self.state.expanded
                ? "transparent"
                : colorFromProps;
            return (
                <div
                    className={classes.statusBar}
                    style={{
                        backgroundColor: color ? color : colorIfCardExpanded
                    }}
                />
            );
        }

        function formatNumber(value) {
            return (
                <NumberFormat
                    value={value ? value : "-"}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    renderText={value => value}
                />
            );
        }

        function renderInfo(title, value) {
            return (
                <div className={classes.infoItem}>
                    <Typography
                        paragraph
                        variant="body2"
                        className={classes.infoItem_title}
                    >
                        {title}:
                    </Typography>
                    <Typography paragraph className={classes.infoItem_value}>
                        {value}
                    </Typography>
                </div>
            );
        }

        function renderProgressInfo(type, title, value, total) {
            let percent = (100 * value) / total;

            return (
                <div className={classes.progressInfo}>
                    <div className={classes.progressInfo_texts}>
                        <Typography
                            variant="body2"
                            className={classes.progressInfo_title}
                        >
                            {title}:
                        </Typography>
                        <Typography className={classes.progressInfo_value}>
                            {formatNumber(value)} / {formatNumber(total)}
                        </Typography>
                    </div>
                    <LinearProgress
                        color={type}
                        variant="determinate"
                        value={percent}
                    />
                </div>
            );
        }

        function renderAction(campaign) {
            let deniedComponent = (
                <div>
                    <Typography
                        className={classes.stateText}
                        color="secondary"
                        style={{ marginBottom: 20 }}
                    >
                        {t("EditingRequired")}
                    </Typography>
                    {renderTwoButtons(renderRemoveBtn())}
                </div>
            );
            let stateComponent = deniedComponent;

            function renderRemoveBtn() {
                return (
                    <Button
                        style={{
                            backgroundColor: THEME.COLOR.GRAY,
                            color: "black"
                        }}
                        variant="raised"
                        onClick={event => self.remove(event, campaign)}
                    >
                        {t("Cancel")}
                    </Button>
                );
            }

            function renderTwoButtons(firstBtn, secondBtn = null) {
                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        {firstBtn}
                        {secondBtn}
                    </div>

                );
            }

            switch (campaign.state) {
                case CAMPAIGN_STATE.DRAFTED.value:
                    stateComponent = renderTwoButtons(
                        renderRemoveBtn(),
                        <Button
                            className={classNames(
                                classes.actionButton,
                                classes.actionButton_blue
                            )}
                            style={{
                                marginLeft: 15
                            }}
                            variant="raised"
                            onClick={event => self.submit(event, campaign)}
                        >
                            {t("SubmitDraftCampaign")}
                        </Button>
                    );
                    break;
                case CAMPAIGN_STATE.TOBEREVIEWED.value:
                    stateComponent = (
                        <div
                            style={{
                                marginTop: 20,
                                alignItems: "baseline",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }}
                        >
                            <Typography
                                className={classes.stateText}
                                color="primary"
                            >
                                {t("WaitingForApproval")}
                            </Typography>
                            {renderRemoveBtn()}
                        </div>
                    );
                    break;
                case CAMPAIGN_STATE.APPROVED.value:
                    stateComponent = (
                        <div
                            style={{
                                marginTop: 20,
                                alignItems: "baseline",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }}
                        >
                            <Typography
                                className={classes.stateText}
                                color="primary"
                            >
                                {t("Approved")}
                            </Typography>
                            {renderTwoButtons(
                        renderRemoveBtn(),
                        <Button
                            className={classNames(
                                classes.actionButton,
                                classes.actionButton_blue
                            )}
                            style={{
                                marginLeft: 15
                            }}
                            variant="raised"
                            onClick={event => self.start(event, campaign)}
                        >
                            {t("CampaignState_ToBeStarted")}
                        </Button>
                        )}
                        </div>
                    );
                    break;
                case CAMPAIGN_STATE.DENIED.value:
                    stateComponent = deniedComponent;
                    break;
                case CAMPAIGN_STATE.STARTED.value:
                    stateComponent = renderTwoButtons(
                        <Button
                            className={classNames(
                                classes.actionButton,
                                classes.actionButton_green
                            )}
                            variant="raised"
                            onClick={event => self.pause(event, campaign)}
                        >
                            {t("Pause")}
                        </Button>
                    );
                    break;
                case CAMPAIGN_STATE.PAUSED.value:
                    stateComponent = renderTwoButtons(
                        <Button
                            style={{
                                backgroundColor: THEME.COLOR.GRAY,
                                color: "black"
                            }}
                            variant="raised"
                            onClick={event => self.finish(event, campaign)}
                        >
                            {t("Stop")}
                        </Button>,
                        <Button
                            style={{marginLeft:20}}
                            className={classNames(
                                classes.actionButton,
                                classes.actionButton_yellow
                            )}
                            variant="raised"
                            onClick={event => self.resume(event, campaign)}
                        >
                            {t("Continue")}
                        </Button>
                    );
                    break;
                case CAMPAIGN_STATE.FINISHED.value:
                    stateComponent = null;
                    break;
                default:
                    break;
            }

            return <div className={classes.stateArea}>{stateComponent}</div>;
        }

        function renderContent(campaign) {
            let isNotStartedCampaign =
                campaign.state === CAMPAIGN_STATE.DRAFTED.value ||
                campaign.state === CAMPAIGN_STATE.TOBEREVIEWED.value ||
                campaign.state === CAMPAIGN_STATE.DENIED.value;

            function render1() {
                return (
                    <div>
                        {renderInfo(t("Budget"), formatNumber(campaign.budget))}
                        {renderInfo(
                            t("Displays"),
                            formatNumber(campaign.needDisplay)
                        )}
                    </div>
                );
            }

            function render2() {
                return (
                    <div>
                        {renderProgressInfo(
                            "secondary",
                            t("Budget"),
                            campaign.usedBudget,
                            campaign.budget
                        )}
                        {renderProgressInfo(
                            "primary",
                            t("Displays"),
                            campaign.countDisplay,
                            campaign.needDisplay
                        )}
                    </div>
                );
            }

            return (
                <CardContent>
                    {renderInfo(
                        t("Timer"),
                        campaign.startDate + " - " + campaign.endDate
                    )}
                    {renderInfo(
                        t("RangeTime"),
                        Campaign.getDisplayTimesString(campaign)
                    )}
                    {renderInfo(t("Zone"), Campaign.getZonesString(campaign))}
                    {renderInfo(
                        t("ExpectedImpressions"),
                        formatNumber(campaign.impression)
                    )}
                    {isNotStartedCampaign ? render1() : render2()}
                    {renderAction(campaign)}
                </CardContent>
            );
        }

        return (
            <div
                className={classes.container}
                onClick={event => this.onClickCampaign(event, campaign)}
            >
                {renderStatusBar()}
                <Card className={classes.card_hover}>
                    <CardHeader
                        action={
                            <IconButton
                                className={classnames(classes.expand, {
                                    [classes.expandOpen]: this.state.expanded
                                })}
                                onClick={event => this.handleExpandClick(event)}
                                aria-expanded={this.state.expanded}
                                aria-label="Show more"
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        }
                        title={campaign.name}
                    />
                    <Collapse
                        in={this.state.expanded}
                        timeout="auto"
                        unmountOnExit
                    >
                        {renderContent(campaign)}
                    </Collapse>
                </Card>
            </div>
        );
    }
}

CampaignListItem.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(
    withStyles(styles)(translate("translations")(CampaignListItem))
);



// WEBPACK FOOTER //
// ./src/HomePage/CampaignListItem.js